import { FlagsProvider, UnleashFlags } from '@lemonade-hq/flags';
import { useInfraContext, useUserContext } from '@lemonade-hq/nuiza';
import { useMemo } from 'react';
import type { FC, PropsWithChildren } from 'react';

export enum Flag {
  SessionReplayEnabled = 'uniclient_mixpanel_session_replay',
}

export interface FlagsConfig {
  readonly url: string;
  readonly clientKey: string;
  readonly environment: string;
}

export const FeatureFlagsProvider: FC<PropsWithChildren<FlagsConfig>> = ({ url, clientKey, environment, children }) => {
  const { user } = useUserContext();
  const infra = useInfraContext();

  const flags = useMemo(() => {
    const client = new UnleashFlags({
      url,
      clientKey,
      environment,
      appName: 'uniclient',
    });

    client.setContext({
      userId: user?.userId,
      properties: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        env_id: infra.envId,
      },
    });

    return client;
  }, [clientKey, environment, infra.envId, url, user?.userId]);

  return <FlagsProvider client={flags}>{children}</FlagsProvider>;
};
